<template>
  <b-modal
    centered
    v-if="isOpen"
    v-model="isOpen"
    cancel-disabled
    hide-footer
    :title="`URL de acesso para o usuário - ${user.email}`"
    size="xl"
    @close="close"
  >
    <b-row>
      <b-col
        cols="12"
        class="d-flex justify-content-end mb-2"
        style="gap: 0.5rem"
      >
        <b-button
          variant="outline-success"
          size="sm"
          :disabled="loading || success"
          v-b-tooltip.hover
          title="Criar um novo acesso ao usuário"
          @click="
            () => {
              $emit('openNewAccess', user);
              close();
            }
          "
        >
          <i class="fas fa-external-link-alt mr-1"></i> Criar novo acesso
        </b-button>
      </b-col>
      <b-col cols="12">
        <b-jumbotron
          bg-variant="light"
          :border-variant="success ? 'success' : error ? 'danger' : 'light'"
          text-variant="dark"
          class="mt-3"
        >
          <template #header>
            <h1
              class="display-5"
              :class="{
                'text-success': success,
                'text-danger': error,
              }"
            >
              <i class="fas fa-check-circle" v-if="success"></i>
              <i class="fas fa-times-circle" v-else-if="error"></i>

              {{ success ? 'Sucesso!' : error ? 'Erro!' : 'Aguarde...' }}
            </h1>
          </template>
          <div class="lead">
            <div v-if="!success && !error">
              Buscando o último acesso do usuário...
            </div>
            <div v-else-if="success">
              O último acesso do usuário foi encontrado com sucesso!
              <div class="fs-12 text-secondary">
                Lembre-se de abrir o link em um outro navegador ou guia anônima,
                para evitar conflitos de sessão.
              </div>
              <div class="fs-12 text-secondary">
                O link se expira em: {{ new Date(expiresAt).toLocaleString('pt-BR') }}
              </div>

              <b-button variant="success" @click="copyLink" class="mt-4">
                <i class="far fa-copy mr-2"></i> Copiar link
              </b-button>

              <div class="fs-14 mt-4">
                ou copie e cole o link abaixo no seu navegador:
                <a :href="fullRedirectLink" target="_blank">
                  {{ baseUrl }}/admin/impersonate/login?token={{ jwtToken }}
                </a>
              </div>
            </div>
            <div v-else-if="error">
              Houve um erro ao buscar o último acesso do usuário.
              <div class="fs-12">{{ errorMessage }}.</div>
            </div>
          </div>
        </b-jumbotron>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import api from '@/api';
import makeToast from 'Mixins/makeToast';
import { mapGetters } from 'vuex';

export default {
  name: 'AccessLinkModal',
  emits: ['openNewAccess'],
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      isOpen: false,
      user: {},
      success: false,
      error: false,
      errorMessage: '',
      jwtToken: '',
      /** @var {Date|null} */
      expiresAt: null,
    };
  },
  computed: {
    ...mapGetters(['getToken']),
    baseUrl() {
      return window.location.origin;
    },
    fullRedirectLink() {
      return `${this.baseUrl}/admin/impersonate/login?token=${this.jwtToken}`;
    },
  },
  methods: {
    open(user) {
      this.isOpen = true;
      this.user = user;
      this.getLastToken();
    },
    close() {
      this.isOpen = false;
      this.user = {};
      this.success = false;
      this.error = false;
      this.errorMessage = '';
      this.jwtToken = '';
    },
    async getLastToken() {
      this.loading = true;
      this.success = false;
      this.error = false;
      this.errorMessage = '';

      try {
        const queryParams = new URLSearchParams({
          targetUserId: this.user.id,
        });

        const response = await api.get(
          `/v1/admin/impersonate/last-token?${queryParams.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
            },
          }
        );
        const { token, expiresAt } = response.data;
        this.jwtToken = token;
        this.expiresAt = expiresAt;
        this.success = true;
      } catch (error) {
        const { message } = error.response.data || {};

        this.error = true;
        this.errorMessage = message || error.message;
      } finally {
        this.loading = false;
      }
    },
    async copyLink() {
      await navigator.clipboard.writeText(this.fullRedirectLink);
      this.makeToast('Sucesso', 'Link copiado com sucesso', 'success');
    },
  },
};
</script>
